import {formatter, request} from '@/utils/request';

export namespace FormSaMkt {
  export const Path = {
    get: '/expenseapi/formSaMkt/getFormSaMkt',
    getFormSaEx: '/expenseapi/formSaMkt/getFormSaMktEx',
    countOfWarning: '/expenseapi/formSaMkt/countOfWarning',
    warningInfos: '/expenseapi/formSaMkt/warningInfos',

  };

  export async function get(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.FormSaMkt>>(Path.get, formatter(options));
  };

  export async function getFormSaEx(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.FormSaMktVo>>(Path.get, formatter(options));
  };

  export async function countOfWarning(formId: number) {
    const options = {
      method: 'GET',
      body: {
        formId: formId,
      },
    };
    return request<API.ResponseResult<number>>(Path.countOfWarning, formatter(options));
  };

  export async function warningInfos(formId: number) {
    const options = {
      method: 'GET',
      body: {
        formId: formId,
      },
    };
    return request<API.ResponseResult<API.WdiPanelList>>(Path.warningInfos, formatter(options));
  };


  export namespace Buttons {
    export const Path = {
      ValidateDetail: '/expenseapi/saMktButtons/validateDetail',
      Validate: '/expenseapi/saMktButtons/validate',
      ValidateAllocate: '/expenseapi/saMktButtons/validateAllocateMonth',
      ValidateAllocateCc: '/expenseapi/saMktButtons/validateAllocateCc',
      Apply: '/expenseapi/saMktButtons/apply',
      Delete: '/expenseapi/saMktButtons/delete',
      DynamicInfos: '/expenseapi/saMktButtons/dynamicInfos',
      BudgetInfos: '/expenseapi/saMktButtons/budgetInfos',
      GetFormSaMktDetailCompareCollections: '/expenseapi/saMktButtons/getFormSaMktDetailCompareCollections'
    };

    export async function validateDetail(body: {
      rowIndex: number,
      formSaMktDetail: any,
      formSaMktDetails: any[],
    }) {
      const options = {
        method: 'POST',
        body: body
      };

      return request<API.ResponseResult<API.FormSaMktDetailVo>>(Path.ValidateDetail, formatter(options));
    };

    export async function validateAllocateCc(body: {
      formSaMktAllocateCcs: API.FormSaMktAllocateCc[],
      current: API.FormSaMktAllocateCc
    }) {
      const options = {
        method: 'POST',
        body: body
      };

      return request<API.ResponseResult<API.FormSaMktAllocateCcVo[]>>(Path.ValidateAllocateCc, formatter(options));
    }

    export async function validateAllocate(body: API.BaseSaMktParam) {
      const options = {
        method: 'POST',
        body: body
      };

      return request<API.ResponseResult<API.FormSaMktDetailAllocateMonth[]>>(Path.ValidateAllocate, formatter(options));
    }

    export async function validate(body: API.DoFormSaMktParam) {
      const options = {
        method: 'POST',
        body: body
      };

      return request<API.ResponseResult<API.FormSaDetailVo>>(Path.Validate, formatter(options));
    }

    export async function apply(body: API.DoFormSaMktParam) {
      const options = {
        method: 'POST',
        body: body
      };
      return request<API.ResponseResult<API.FormSaDetailVo>>(Path.Apply, formatter(options));
    }

    export async function del(formId: number) {
      const options = {
        method: 'POST',
        body: {
          formId: formId,
        },
      };
      return request<API.ResponseResult<API.WdiPanelList>>(Path.Delete, formatter(options));
    }

    export async function dynamicInfos(formId: number) {
      const options = {
        method: 'Get',
        body: {formId}
      };
      return request<API.DynamicInformation[]>(Path.DynamicInfos, formatter(options));
    };

    export async function getFormSaMktDetailCompareCollections(body: { formId: number, relatedFormId: number }) {
      const options = {
        method: 'GET',
        body: {
          ...body
        },
      };
      return request<API.ResponseResult<API.FormSaMktDetailCompareCollections>>(Path.GetFormSaMktDetailCompareCollections, formatter(options));
    };

    export async function budgetInfos(formId: number) {
      const options = {
        method: 'GET',
        body: {formId}
      };
      return request<API.ResponseResult<any>>(Path.BudgetInfos, formatter(options));
    };
  }
}

export namespace FormSaMktDetail {
  export const Path = {
    gets: '/expenseapi/formSaMkt/getFormSaMktDetails',
    getsEx: '/expenseapi/formSaMkt/getFormSaMktDetailsEx',
    getFormSaMktDetailsCompany: '/expenseapi/formSaMkt/getFormSaMktDetailsCompany',
  };

  export async function gets(formSaMktId: number) {
    const options = {
      method: 'GET',
      body: {
        formSaMktId: formSaMktId,
      },
    };
    return request<API.ResponseResult<API.FormSaMktDetail[]>>(Path.gets, formatter(options));
  }

  export async function getsEx(formSaMktId: number) {
    const options = {
      method: 'GET',
      body: {
        formSaMktId: formSaMktId,
      },
    };
    return request<API.ResponseResult<API.FormSaMktDetailVo[]>>(Path.getsEx, formatter(options));
  }

  export async function getFormSaMktDetailsCompany(formSaMktId: number) {
    const options = {
      method: 'GET',
      body: {
        formSaMktId: formSaMktId,
      },
    };
    return request<API.ResponseResult<API.FormSaMktDetailVo[]>>(Path.getFormSaMktDetailsCompany, formatter(options));
  }

}
export namespace FormSaMktAllocateCc {
  export const Path = {
    Gets: '/expenseapi/formSaMkt/getFormSaMktAllocateCcs',
  };

  export async function gets(formSaMktId: number) {
    const options = {
      method: 'GET',
      body: {
        formSaMktId: formSaMktId,
      },
    };
    return request<API.ResponseResult<API.FormSaMktDetailAllocateMonth[]>>(Path.Gets, formatter(options));
  }
}

export namespace FormSaMktAllocateMonth {
  export const Path = {
    Gets: '/expenseapi/formSaMkt/getFormSaMktAllocateMonths',
    Init: '/expenseapi/formSaMkt/initFormSaMktAllocateMonth',
  };

  export async function init(body: { startDate: string, endDate: string, allMonthRemark: API.FormSaMktDetailAllocateMonth[] }) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.FormSaMktDetailAllocateMonth[]>>(Path.Init, formatter(options));
  }

  export async function gets(formSaMktId: number) {
    const options = {
      method: 'GET',
      body: {
        formSaMktId: formSaMktId,
      },
    };
    return request<API.ResponseResult<API.FormSaMktDetailAllocateMonth[]>>(Path.Gets, formatter(options));
  }
}
